import { AUTH_STORAGE_KEYS } from '@sync-video/types';

export function readRefreshToken(): string | null {
  return localStorage.getItem(AUTH_STORAGE_KEYS.refreshToken);
}

export function clearSession(): void {
  localStorage.removeItem(AUTH_STORAGE_KEYS.refreshToken);
}
